import {Directive, ElementRef, HostListener, Input, Renderer2, SimpleChanges} from "@angular/core";
import {ListSortOrder} from "@model";
import {SortableTableComponent} from "@components";

@Directive({
  selector: '[sortBy]',
})
export class SortableColumn {
  @Input({required: true}) sortBy?: any[];
  @Input() defaultOrder: ListSortOrder = ListSortOrder.ASC

  dataType: string | undefined;
  id?: string;
  iconHolder?: HTMLElement;
  sortIcon: HTMLElement = this.createSortIcon();
  hoverIcon: HTMLElement = this.createHoverIcon();
  isActive: boolean = false;
  order: ListSortOrder = this.defaultOrder;

  constructor(public elementRef: ElementRef, private table: SortableTableComponent, private renderer: Renderer2) {

  }

  ngOnInit() {
    this.dataType = this.elementRef.nativeElement.getAttribute("data-type");
    this.id = this.sortBy?.join(".");
    this.iconHolder = this.elementRef.nativeElement.querySelector(".icon-holder") ?? this.elementRef.nativeElement
    this.renderer.appendChild(this.iconHolder, this.sortIcon);
    this.renderer.appendChild(this.iconHolder, this.hoverIcon);
  }


  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.preventDefault();
    if (this.sortBy) {
      if (this.isActive) {
        this.order = this.order === ListSortOrder.ASC ? ListSortOrder.DESC : ListSortOrder.ASC;
      }
      this.table.sort(this.id);
      this.toggleIcon(this.sortIcon, this.order);
    }
  }

  @HostListener('mouseover', ['$event'])
  onMouseOver(event: Event) {
    event.preventDefault();
    if (this.table.items) {
      if (!this.isActive) {
        this.displayIcon(this.hoverIcon, "0.3");
      }
    }
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: Event) {
    event.preventDefault();
    if (this.table.items) {
      if (!this.isActive) {
        this.hideIcon(this.hoverIcon);
      }
    }
  }

  public activate() {
    this.isActive = true;
    this.displayIcon(this.sortIcon, '1');
    this.hideIcon(this.hoverIcon);

  }

  public deactivate(): void {
    this.isActive = false;
    this.order = this.defaultOrder;
    this.hideIcon(this.sortIcon);
    this.hideIcon(this.hoverIcon);
  }


  public get sortingParams(): [sortBy?: any[], order?: ListSortOrder, type?: string] {
    return [this.sortBy, this.order, this.dataType ?? ""]
  }

  private createSortIcon(): HTMLElement {
    const icon: HTMLElement = this.renderer.createElement('i');
    icon.id = "sortIcon"
    icon.classList.add('ps-2', 'fa-solid', 'color-primary', 'fs-12', this.getIcon(this.defaultOrder));
    icon.style.display = "none";
    return icon;
  }

  private createHoverIcon(): HTMLElement {
    const icon: HTMLElement = this.renderer.createElement('i');
    icon.classList.add('ps-2', 'fa-solid', 'color-primary', 'fs-12', this.getIcon(this.defaultOrder));
    icon.style.opacity = "30%";
    icon.style.display = "none";
    return icon;
  }

  private displayIcon(icon: HTMLElement, opacity: string): void {
    this.renderer.setStyle(icon, "display", "inline-block")
  }

  private hideIcon(icon: HTMLElement): void {
    this.renderer.setStyle(icon, 'display', 'none');
  }

  private toggleIcon(icon: HTMLElement, order: ListSortOrder): void {
    icon.classList.remove('fa-arrow-down', 'fa-arrow-up')
    icon.classList.add(this.getIcon(order));
  }

  private getIcon(order: ListSortOrder): string {
    switch (order) {
      case ListSortOrder.DESC:
        return 'fa-arrow-down';
      case ListSortOrder.ASC:
        return 'fa-arrow-up';
    }
  }

}
